import styles from './Groups.module.css';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import SearchBar from '../../components/SearchBar/SearchBar';
import Dropdown from '../../components/Dropdown/Dropdown';
import { IoMdTrash } from 'react-icons/io';
import Dynamic from '../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import Action from '../../components/Action/Action';
import FixedLogoWithName from '../../components/FixedLogoWithName/FixedLogoWithName';
import IconAndName from '../../components/IconAndName/IconAndName';
import { IoAddCircleOutline } from 'react-icons/io5';
import CopyRight from '../../components/CopyRight/CopyRight';

const data = [
  {
    _id: 'gnswkgnseknsg1',
    GroupName: 'king',
    color: 'blue',
    NoofStudents: '4685',
    Actions: ['Add Student', 'Delete'],
  },
];

function Groups() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleGroup = () => {
    dispatch(openModal('addGroup'));
  };

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        GroupName: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              minWidth: '200px',
            }}
          >
            <input
              type="checkbox"
              style={{ width: 'max-content' }}
              checked={isChecked}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedIds((prev) =>
                  checked
                    ? [...prev, item._id]
                    : prev.filter((id) => id !== item._id)
                );
              }}
            />
            <FixedLogoWithName
              label={item.GroupName}
              color={item.color || 'green'}
            />
          </div>
        ),
        NoofStudents: (
          <span
            style={{
              color: 'var(--Primary_Color)',
              cursor: 'pointer',
              fontWeight: 400,
            }}
          >
            {item.NoofStudents} Students
          </span>
        ),
        Actions: (
          <Action
            key={item._id}
            options={item.Actions || ['Add Student', 'Delete']}
            onSelect={(opt) => {
              if (opt === 'Add Student') {
                dispatch(openModal('AddStudentToGroup'));
              } else if (opt === 'Delete') {
                dispatch(openModal('delete'));
              }
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <input
            type="checkbox"
            style={{ width: 'max-content' }}
            checked={selectedIds.length === data.length}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds(checked ? data.map((item) => item._id) : []);
            }}
          />
          <span>Group Name</span>
        </div>
      ),
      accessor: 'GroupName',
    },
    { title: 'No.of Students', accessor: 'NoofStudents' },
    { title: 'Action', accessor: 'Actions' },
  ];

  return (
    <>
      <div className={styles.headerContainer}>
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search group "
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
            <div className={styles.Addroom}>
              <IconAndName
                icon={<IoAddCircleOutline />}
                title="Add Group"
                bgColor="Primary_Color"
                onClick={handleGroup}
              />
            </div>
          </div>

          <div className={styles.dynamicdata}>
            <Dynamic
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>

      <div className={styles.copyRightContainer}>
        <CopyRight />
      </div>
    </>
  );
}

export default Groups;
